module.exports = __webpack_public_path__ + "img/smart--phone.b5abfd0e.svg";